module.exports = __webpack_public_path__ + "img/2b5c6f0.png";